function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrowDown_svg__arrowDown_svg__clip0)",
  fill: "#0071EB"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.617 10.459l4.994-4.006 2.425 2.293-9.41 7.156-9.41-7.156 2.426-2.293 4.994 4.006V0h3.981v10.459zM0 16.636h19.037V20H0v-3.364z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrowDown_svg__arrowDown_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19.037v20H0z"
})));

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xMS42MTcgMTAuNDU4N0wxNi42MTEzIDYuNDUyNkwxOS4wMzYxIDguNzQ2MThMOS42MjY0NyAxNS45MDIxTDAuMjE2Nzk3IDguNzQ2MThMMi42NDE2IDYuNDUyNkw3LjYzNTk2IDEwLjQ1ODdWMEgxMS42MTdWMTAuNDU4N1oiIGZpbGw9IiMwMDcxRUIiLz4KPHBhdGggZD0iTTAgMTYuNjM2MkgxOS4wMzY1VjIwLjAwMDFIMFYxNi42MzYyWiIgZmlsbD0iIzAwNzFFQiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjE5LjAzNjUiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgArrowDown as ReactComponent };